// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSecondaryCourseDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryCourseDTO from '../models/SecondaryCourseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: string | null;
    academicYear: number | null | null;
    secondaryCourseId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: '00000000-0000-0000-0000-000000000000',
            academicYear: null,
            secondaryCourseId: null,
        },
        initValues);
    },
    id: 'id',
    academicYear: 'academicYear',
    secondaryCourseId: 'secondaryCourseId',
}

interface Result extends ResultDTO {
    secondaryCourse: SecondaryCourseDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            secondaryCourse: null,
        },
        initValues);
    },
    secondaryCourse: 'secondaryCourse',
}

export { Request, Result };